import { CommonModule } from '@angular/common';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { RouterModule } from '@angular/router';
import {
  LoadingComponent,
  NotFoundComponent,
  AuthorizeDirective,
  ToolbarComponent,
  NavigationDrawerComponent,
  UnauthorizedComponent,
  AddressComponent,
  ApprovedAddressesComponent,
  PhoneNumberPipe,
  MiddleEllipsisPipe,
  CampusUnitSelectComponent,
  LocalWardSelectComponent,
  ContentOrErrorComponent,
  ChurchUnitPipe,
  WardComplexesComponent,
  SortPipe,
  StudentListingPipe,
  MissionNamePipe,
  EmailPipe,
  CampusUnitMessageComponent,
  CampusUnitMessageDisplayComponent,
  CampusUnitMessageEditDialogComponent,
  EmptyResponseRecievedComponent,
} from '../shared';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HomePageComponent } from './components/home-page/home-page.component';
import { EditorModule } from '@tinymce/tinymce-angular';

@NgModule({
  imports: [
    CommonModule,
    ExcelExportModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatExpansionModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDividerModule,
    MatListModule,
    MatTableModule,
    MatDialogModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatSnackBarModule,
    PDFExportModule,
    EditorModule
  ],
  declarations: [
    LoadingComponent,
    AuthorizeDirective,
    NotFoundComponent,
    ToolbarComponent,
    NavigationDrawerComponent,
    UnauthorizedComponent,
    AddressComponent,
    PhoneNumberPipe,
    ApprovedAddressesComponent,
    CampusUnitSelectComponent,
    LocalWardSelectComponent,
    ContentOrErrorComponent,
    LocalWardSelectComponent,
    ChurchUnitPipe,
    MiddleEllipsisPipe,
    WardComplexesComponent,
    SortPipe,
    MissionNamePipe,
    EmailPipe,
    StudentListingPipe,
    CampusUnitMessageComponent,
    CampusUnitMessageDisplayComponent,
    CampusUnitMessageEditDialogComponent,
    EmptyResponseRecievedComponent,
    HomePageComponent
  ],
  exports: [
    RouterModule,
    CommonModule,
    ExcelExportModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PhoneNumberPipe,
    ChurchUnitPipe,
    LoadingComponent,
    AddressComponent,
    ApprovedAddressesComponent,
    CampusUnitSelectComponent,
    LocalWardSelectComponent,
    ContentOrErrorComponent,
    AuthorizeDirective,
    ToolbarComponent,
    NavigationDrawerComponent,
    CampusUnitMessageEditDialogComponent,
    EmptyResponseRecievedComponent,
    MatButtonModule,
    MatCardModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatListModule,
    MatExpansionModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDividerModule,
    MatTableModule,
    MatDialogModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    WardComplexesComponent,
    SortPipe,
    MissionNamePipe,
    EmailPipe,
    StudentListingPipe,
    MatNativeDateModule,
    PDFExportModule,
    EditorModule
  ],
  entryComponents: [
    CampusUnitMessageEditDialogComponent
  ]
})
export class SharedModule {}
